import { isWahaInbox } from 'dashboard/api/wahaManager';

// Explicitly designated Amazon mailbox. Inbox names are mutable, not identities.
const AMAZON_EMAIL_INBOXES = { 1: [3] };

export function isReplyOnlyInbox(inbox, accountId) {
  if (!inbox) return false;
  if (isWahaInbox(inbox) || inbox.channel_type === 'Channel::Whatsapp' ||
      (inbox.channel_type === 'Channel::TwilioSms' && inbox.medium === 'whatsapp')) return true;
  return inbox.channel_type === 'Channel::Email' &&
    (AMAZON_EMAIL_INBOXES[Number(accountId)] || []).includes(Number(inbox.id));
}
